import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  makeStyles,
  Typography
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ConfigServicePackagePanel from './ConfigServicePackagePanel';

export default function ConfigServicePackageModal({ open, onClose, agencySelected }) {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Typography variant="h6" style={{ fontWeight: 700, color: '#fff' }}>
          Cấu hình gói cước đại lý: {agencySelected?.name || ''}
        </Typography>
        <IconButton className={classes.closeBtn} onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers className={classes.content}>
        <ConfigServicePackagePanel agencySelected={agencySelected} hideTitle={true} />
      </DialogContent>

      <DialogActions style={{ padding: '12px 24px' }}>
        <Button onClick={onClose} style={{ textTransform: 'none', color: '#666' }}>
          Đóng
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const useStyles = makeStyles(theme => ({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px',
    backgroundColor: '#D9042F',
    color: '#fff'
  },
  closeBtn: { color: '#fff' },
  content: { padding: '16px 24px' }
}));
